import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { UtilBranchSettingsContainerComponent } from '../branch-settings/branch-settings-container/branch-settings-container.component';
import { UtilBranchSettingsListingComponent } from '../branch-settings/branch-settings-container/branch-settings-listing/branch-settings-listing.component';
import { UtilBranchDetailsComponent } from '../branch-settings/branch-settings-container/branch-details/branch-details.component';
import { UtilBranchEditComponent } from '../branch-settings/branch-settings-container/branch-edit/branch-edit.component';
import { BranchSettingsEffects } from './branch-settings-controller/effects/branch-settings.effects';
import { branchSettingsFeatureKey } from './branch-settings-controller/reducers/branch-settings.reducers';
import { branchSettingsReducers } from './branch-settings-controller/reducers/root';
import { SharedUtilitiesModule } from '../../utilities/shared-utilities.module';
import { BranchSettingsFacade } from './facades/branch-settings.facade';
import { BranchViewCacheModule } from './view-cache.module';
import { UtilBranchItemCategoryFilterComponent } from '../branch-settings/branch-settings-container/item-category-filter/item-category-filter.component';
import { UtilBranchMenuListComponent } from '../branch-settings/branch-settings-container/menu-list/menu-list.component';
import { UtilBranchPricingSchemeListingComponent } from '../branch-settings/branch-settings-container/pricing-scheme/listing/listing.component';
import { UtilBranchPricingSchemeCreateComponent } from '../branch-settings/branch-settings-container/pricing-scheme/create/create.component';
import { UtilBranchPricingSchemeEditComponent } from '../branch-settings/branch-settings-container/pricing-scheme/edit/edit.component';
import { UtilBranchDefaultSettlementMethodComponent } from '../branch-settings/branch-settings-container/default-settlement-method/default-settlement-method.component';
import { BranchPrintableListingComponent } from '../branch-settings/branch-settings-container/printable-format/listing/listing.component';
import { BranchPrintableAddComponent } from '../branch-settings/branch-settings-container/printable-format/add/add.component';
import { BranchPrintableEditComponent } from '../branch-settings/branch-settings-container/printable-format/edit/edit.component';
import { BranchPrintableImageListingComponent } from '../branch-settings/branch-settings-container/printable-image/listing/listing.component';
import { BranchPrintableImageLinkListingComponent } from '../branch-settings/branch-settings-container/printable-format/edit/image/listing/listing.component';
import { BranchPrintableImageLinkAddComponent } from '../branch-settings/branch-settings-container/printable-format/edit/image/add/add.component';
import { BranchPrintableImageLinkEditComponent } from '../branch-settings/branch-settings-container/printable-format/edit/image/edit/edit.component';
import { BranchPrintableImageAddComponent } from '../branch-settings/branch-settings-container/printable-image/add/add.component';
import { BranchPrintableImageEditComponent } from '../branch-settings/branch-settings-container/printable-image/edit/edit.component';
import { BranchEmployeeLinkListingComponent } from '../branch-settings/branch-settings-container/employee/listing/listing.component';
import { BranchEmployeeLinkAddComponent } from '../branch-settings/branch-settings-container/employee/add/add.component';
import { BranchEmployeeLinkEditComponent } from '../branch-settings/branch-settings-container/employee/edit/edit.component';

export const branchSettingsAgGridModule = AgGridModule.withComponents([]);
export const branchSettingsStoreModule = StoreModule.forFeature(branchSettingsFeatureKey, branchSettingsReducers.branchSettings);
export const branchSettingsEffectsModule = EffectsModule.forFeature([BranchSettingsEffects]);

@NgModule({
  declarations: [
    UtilBranchSettingsContainerComponent,
    UtilBranchSettingsListingComponent,
    UtilBranchEditComponent,
    UtilBranchDetailsComponent,
    UtilBranchItemCategoryFilterComponent,
    UtilBranchMenuListComponent,
    UtilBranchPricingSchemeListingComponent,
    UtilBranchPricingSchemeCreateComponent,
    UtilBranchPricingSchemeEditComponent,
    UtilBranchDefaultSettlementMethodComponent,
    BranchPrintableListingComponent,
    BranchPrintableAddComponent,
    BranchPrintableEditComponent,
    BranchPrintableImageListingComponent,
    BranchPrintableImageLinkListingComponent,
    BranchPrintableImageLinkAddComponent,
    BranchPrintableImageLinkEditComponent,
    BranchPrintableImageAddComponent,
    BranchPrintableImageEditComponent,
    BranchEmployeeLinkListingComponent,
    BranchEmployeeLinkAddComponent,
    BranchEmployeeLinkEditComponent
  ],
  imports: [
    CommonModule,
    BranchViewCacheModule,
    SharedUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    branchSettingsAgGridModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule,
    branchSettingsStoreModule,
    branchSettingsEffectsModule
  ],
  providers: [
    BranchSettingsFacade
  ]
})
export class BranchSettingsModule { }
